/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPINDIVIDUALWITHHOLDINGTAXDECLARATION = {
    ExemptionParagraph: 'EFT',
    Both: 'DR',
    ReducedRate: 'RRT'
} as const;
export type IAPINDIVIDUALWITHHOLDINGTAXDECLARATION = typeof IAPINDIVIDUALWITHHOLDINGTAXDECLARATION[keyof typeof IAPINDIVIDUALWITHHOLDINGTAXDECLARATION];


export function IAPINDIVIDUALWITHHOLDINGTAXDECLARATIONFromJSON(json: any): IAPINDIVIDUALWITHHOLDINGTAXDECLARATION {
    return IAPINDIVIDUALWITHHOLDINGTAXDECLARATIONFromJSONTyped(json, false);
}

export function IAPINDIVIDUALWITHHOLDINGTAXDECLARATIONFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPINDIVIDUALWITHHOLDINGTAXDECLARATION {
    return json as IAPINDIVIDUALWITHHOLDINGTAXDECLARATION;
}

export function IAPINDIVIDUALWITHHOLDINGTAXDECLARATIONToJSON(value?: IAPINDIVIDUALWITHHOLDINGTAXDECLARATION | null): any {
    return value as any;
}

